/**
 *
 */
export enum OpResponseCode {
  OPERATION_SUCCESSFUL = 1000,
  GENERAL_ERROR = 1078,
  ADVERT_NOT_FOUND = 1015,
}
